import { ManagementProfile } from '../../shared/models/management.model';

type ManagementProfilesResponse = {
  Data?: unknown;
  data?: unknown;
  Items?: unknown;
  items?: unknown;
  Profiles?: unknown;
  profiles?: unknown;
  Result?: unknown;
  result?: unknown;
  ManagementProfiles?: unknown;
  managementProfiles?: unknown;
};

export function extractManagementProfiles(payload: unknown): ManagementProfile[] {
  if (Array.isArray(payload)) {
    return payload.map(normalizeManagementProfile).filter(isManagementProfile);
  }

  if (payload && typeof payload === 'object') {
    const response = payload as ManagementProfilesResponse;
    const collection =
      response.Data ??
      response.data ??
      response.Items ??
      response.items ??
      response.Profiles ??
      response.profiles ??
      response.Result ??
      response.result ??
      response.ManagementProfiles ??
      response.managementProfiles;

    if (Array.isArray(collection)) {
      return collection.map(normalizeManagementProfile).filter(isManagementProfile);
    }
  }

  console.warn('Unexpected management profiles payload shape', payload);
  return [];
}

function normalizeManagementProfile(value: unknown): Partial<ManagementProfile> {
  if (!value || typeof value !== 'object') {
    return {};
  }

  const raw = value as Record<string, unknown>;
  const message = normalizeMessage(raw['message'] ?? raw['Message']);

  return {
    id: toString(raw['id'] ?? raw['Id']),
    name: toString(raw['name'] ?? raw['Name']),
    qualification: toString(raw['qualification'] ?? raw['Qualification']),
    designation: toString(raw['designation'] ?? raw['Designation']),
    institution: toOptionalString(raw['institution'] ?? raw['Institution']),
    descriptions: toStringArray(raw['descriptions'] ?? raw['Descriptions']),
    route: toString(raw['route'] ?? raw['Route']),
    image: toString(raw['image'] ?? raw['Image']),
    profileImage: toOptionalString(raw['profileImage'] ?? raw['ProfileImage']),
    additionalDescriptions: toOptionalStringArray(raw['additionalDescriptions'] ?? raw['AdditionalDescriptions']),
    message
  };
}

function normalizeMessage(value: unknown): ManagementProfile['message'] {
  if (!value || typeof value !== 'object') {
    return undefined;
  }

  const raw = value as Record<string, unknown>;

  return {
    title: toOptionalString(raw['title'] ?? raw['Title']),
    greeting: toOptionalString(raw['greeting'] ?? raw['Greeting']),
    quote: toOptionalString(raw['quote'] ?? raw['Quote']),
    paragraphs: toStringArray(raw['paragraphs'] ?? raw['Paragraphs']),
    closing: toOptionalString(raw['closing'] ?? raw['Closing']),
    sign: toString(raw['sign'] ?? raw['Sign']),
    title_sign: toOptionalString(raw['title_sign'] ?? raw['TitleSign']),
    signatureImage: toOptionalString(raw['signatureImage'] ?? raw['SignatureImage']),
    email: toOptionalString(raw['email'] ?? raw['Email'])
  };
}

function toString(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

function toOptionalString(value: unknown): string | undefined {
  return typeof value === 'string' && value ? value : undefined;
}

function toStringArray(value: unknown): string[] {
  return Array.isArray(value) ? value.filter((entry): entry is string => typeof entry === 'string') : [];
}

function toOptionalStringArray(value: unknown): string[] | undefined {
  const normalized = toStringArray(value);
  return normalized.length ? normalized : undefined;
}

function isManagementProfile(value: unknown): value is ManagementProfile {
  if (!value || typeof value !== 'object') {
    return false;
  }

  const profile = value as ManagementProfile;
  return !!profile.id;
}